export default "__VITE_ASSET__ClTgxGtV__"